/* eslint-disable */
import React from 'react';
import * as MUI from '@material-ui/core';
import cn from 'classnames';
import { useStyles } from './styles';
import ExpandPolygonIcon from '../../../../../../icons/ExpandPolygon';

export const GlobalCategoryTitle = ({ children, ...props }) => {
  const { parent } = props;
  const { toggleExpand } = parent as any;
  const classes = useStyles(props);
  const expanded = parent.expanded;
  const classNameIcon = cn(classes.globalCategoryTitleIcon, {
    'rotate': expanded
  });
  return (
    <MUI.AccordionSummary onClick={toggleExpand} className={classes.globalCategoryTitle}>
      <ExpandPolygonIcon className={classNameIcon} />
      {children}
    </MUI.AccordionSummary>
  );
}

export default GlobalCategoryTitle;
